import React, { useState } from 'react';
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper
} from '@mui/material';
//import AdultTattooConsentForm from './AdultTattooConsentForm';
//import AdultPiercingConsentForm from './AdultPiercingConsentForm';
//import ClientScreeningForm from './ClientScreeningForm';
import CustomFormManager from './CustomFormManager';

const FormSelector = () => {
  const [selectedForm, setSelectedForm] = useState('');

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Consent Form Selection
      </Typography>
      
      <FormControl fullWidth sx={{ mb: 3 }} variant="outlined">
        <InputLabel id="form-select-label">Select Consent Form</InputLabel>
        <Select
          labelId="form-select-label"
          value={selectedForm}
          onChange={(e) => setSelectedForm(e.target.value)}
          label="Select Consent Form"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          
          {/* TEMPORARILY REMOVED - Standard Forms */}
          {/*
          <MenuItem value="adultTattoo">Adult Tattoo Consent Form</MenuItem>
          <MenuItem value="adultPiercing">Adult Piercing Consent Form</MenuItem>
          <MenuItem value="clientScreening">Client Screening Form</MenuItem>
          */}
          
          {/* Custom Forms - removed fontWeight="bold" */}
          <MenuItem value="customForms">
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="body1">
                Custom Forms
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Create and manage your own consent forms
              </Typography>
            </Box>
          </MenuItem>
        </Select>
      </FormControl>

      {selectedForm && (
        <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
          {/* TEMPORARILY REMOVED - Form Components */}
          {/*
          {selectedForm === 'adultTattoo' && <AdultTattooConsentForm />}
          {selectedForm === 'adultPiercing' && <AdultPiercingConsentForm />}
          {selectedForm === 'clientScreening' && <ClientScreeningForm />}
          */}
          {selectedForm === 'customForms' && <CustomFormManager />}
        </Paper>
      )}
    </Box>
  );
};

export default FormSelector;